import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "components/ui/dialog";

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "components/ui/alert-dialog";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "components/ui/select";
import { Label } from "components/ui/label";
import { Input } from "components/ui/input";

import { fetchAxiosToken } from "helpers/fetchAxiosToken";
import { toast } from "components/ui/use-toast";

import { ReloadIcon } from "@radix-ui/react-icons";

import { Switch } from "components/ui/switch";
import { ScheduleBlocked } from "./UpdateScheduleBlocked";
import dayjs from "dayjs";
import { set } from "date-fns";
import { fetchAxiosNoToken } from "helpers/fetchAxiosNoToken";
import { Button } from "components/ui/button";
import { useAppSelector } from "hooks/hooks";

interface Props {
    setEdit: (visible: ScheduleBlocked | null) => void;
    edit: ScheduleBlocked;
    getEvents: () => void;
}
interface User {
    name: string;
    last_name: string;
    specialty: string;
}
export interface Intervals {
    closing_time: string;
    opening_time: string;
}

interface patient {
    id: number;
    nombre: string;
    apellido: string;
    correo: string;
    celular: string;
    avatar: string;
    tipo_contacto: string;
    fecha_ultima_reserva: string;
    id_pedido: number;
    id_crm: number;
    etapa_crm: string;
}

export const ShiftCalendarModal = ({ setEdit, edit, getEvents }: Props) => {
    const startDate = new Date(edit.start).toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
    });
    const endDate = new Date(edit.end);

    const [startTime, setStartTime] = useState<string>();
    const [endTime, setEndTime] = useState<string>();
    const [intervals, setIntervals] = useState<Intervals[]>([]);
    const { id } = useAppSelector((state) => state.usuario_logeado);

    const [toggleButton, setToggleButton] = useState(false);
    const [deleteShift, setDeleteShift] = useState(false);

    const [patientSelected, setPatientSelected] = useState<patient | null>(
        null
    );

    const [status, setStatus] = useState("");

    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const data = await fetchAxiosToken({
                url: `/visitas_agendadas/updateVisitaAgendada/${edit.id}`,
                method: "put",
                body: {
                    fecha: `${dayjs(edit.start).format("YYYY-MM-DD")}`,
                    estado: "Agendado",
                    hora_inicio: startTime,
                    hora_final: endTime,
                    nota: "",
                },
            });

            getEvents();
            toast({
                title: "Turno actualizado correctamente",
            });

            setEdit(null);
            setLoading(false);
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            const data = await fetchAxiosToken({
                url: `/visitas_agendadas/updateHabilitadoVisitaAgendada/${edit.id}`,
                method: "put",
                body: {
                    habilitado: "No",
                    by: "Propietario",
                },
            });

            getEvents();
            toast({
                title: "Visita eliminada correctamente",
            });
            setLoading(false);
            setEdit(null);
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const data = await fetchAxiosNoToken({
                url: `/reserves/confirm-by-email/${patientSelected?.id}/${edit.id}`,
                method: "put",
            });
            getEvents();
            toast({
                title: "Turno confirmado correctamente",
            });
            setLoading(false);

            setEdit(null);
        } catch (error: any) {
            console.error("Error:", error);

            toast({
                variant: "destructive",
                title: "Error al confirmar el turno",
                description: `${error.response.data?.message}`,
            });
            setLoading(false);
        }
    };

    const getOffices = async () => {
        try {
            const dataReserve = await fetchAxiosToken({
                url: `/visitas_agendadas/getOneVisitaAgendada/${edit.id}`,
                method: "get",
            });

            setStartTime(dataReserve.hora_inicio.slice(0, -3));
            setEndTime(dataReserve.hora_final.slice(0, -3));

            const dataInterval = await fetchAxiosToken({
                url: `/horarios_asesores/getIntervals/${id}`,
                body: {
                    date: dayjs(edit.start).format("YYYY-MM-DD"),
                },
                method: "post",
            });
            const intervalsNew = [
                {
                    closing_time: dataReserve.hora_final.slice(0, -3),
                    opening_time: dataReserve.hora_inicio.slice(0, -3),
                },
                ...dataInterval.intervals,
            ];
            setIntervals(intervalsNew);
            setPatientSelected(dataReserve.usuario);
            setStatus(dataReserve.estado);
        } catch (error: any) {
            console.log(error);
        }
    };

    const setTimeOfTurn = (value: string) => {
        const time = intervals.find((time) => time.opening_time === value);
        if (time) {
            setStartTime(value);
            setEndTime(time.closing_time);
        }
    };
    useEffect(() => {
        getOffices();
    }, []);

    return (
        <div className="absolute">
            <Dialog defaultOpen={true} onOpenChange={() => setEdit(null)}>
                <DialogContent className="sm:max-w-[425px]">
                    <div className="absolute z-[999] flex items-center gap-2 text-xs  xs:text-sm top-10 right-4 font-poppins-regular sm:text-base ">
                        <p className="cursor-pointer">Editar</p>
                        <Switch
                            onClick={(e) => {
                                setToggleButton(!toggleButton);
                            }}
                        />
                    </div>
                    <DialogHeader>
                        <DialogTitle className="capitalize">
                            {" "}
                            {edit
                                ? ` ${dayjs(edit.start).format(
                                      "dddd"
                                  )} ${new Date(
                                      edit.start
                                  ).toLocaleDateString()}`
                                : ""}
                        </DialogTitle>
                        <DialogDescription>
                            Datos sobre el turno
                        </DialogDescription>
                    </DialogHeader>

                    {patientSelected ? (
                        <div className="grid gap-4 py-4">
                            <div className="grid items-center grid-cols-1 gap-4">
                                <Label className="col-span-4">Cliente</Label>

                                <div className="flex items-start gap-2">
                                    <img
                                        src={`${process.env.REACT_APP_PROXY}/usuarios/getImage/${patientSelected.avatar}`}
                                        alt="avatar"
                                        className="w-10 h-10 rounded-full"
                                    />
                                    <div className="flex flex-col w-full gap-2">
                                        <Input
                                            disabled
                                            type="text"
                                            className="flex flex-col w-full "
                                            id="last_name"
                                            value={`${patientSelected.nombre} ${patientSelected.apellido}`}
                                        />
                                        <Input
                                            disabled
                                            type="text"
                                            className="flex flex-col w-full "
                                            id="last_name"
                                            value={`${patientSelected.correo}`}
                                        />
                                        <Input
                                            disabled
                                            type="text"
                                            className="flex flex-col w-full "
                                            id="last_name"
                                            value={`${patientSelected.celular}`}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="grid items-center grid-cols-4 gap-4">
                                <Label className="col-span-4">Hora</Label>
                                <div className="col-span-4">
                                    <Select
                                        value={startTime}
                                        disabled={!toggleButton}
                                        onValueChange={(value) =>
                                            setTimeOfTurn(value)
                                        }>
                                        <SelectTrigger
                                            translate="no"
                                            className="w-full">
                                            <SelectValue
                                                translate="no"
                                                placeholder="Selecciona la hora"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup
                                                translate="no"
                                                className="py-6 xs400:py-2">
                                                {intervals.map(
                                                    (time, index) => (
                                                        <SelectItem
                                                            translate="no"
                                                            key={index}
                                                            value={
                                                                time.opening_time
                                                            }>
                                                            {time.opening_time}
                                                        </SelectItem>
                                                    )
                                                )}
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="items-center justify-center w-full py-4">
                            <ReloadIcon className="w-12 h-12 mx-auto animate-spin text-blue-consulta-900" />
                        </div>
                    )}
                    <DialogFooter>
                        {loading ? (
                            <div className="flex items-center justify-center w-full">
                                <ReloadIcon className="w-8 h-8 mr-2 animate-spin" />
                            </div>
                        ) : (
                            <>
                                {status === "Por confirmar" && (
                                    <Button
                                        onClick={() => handleSubmit()}
                                        type="button"
                                        className="hover:bg-lime-200 bg-lime-400">
                                        Confirmar visita
                                    </Button>
                                )}
                                <Button
                                    onClick={() => setDeleteShift(true)}
                                    type="button"
                                    className="bg-red-400 hover:bg-red-200">
                                    Cancelar visita
                                </Button>

                                <Button
                                    className="bg-[#029BFC]"
                                    disabled={loading}
                                    onClick={() => handleSubmit()}
                                    type="submit">
                                    {loading ? (
                                        <>
                                            <ReloadIcon className="w-4 h-4 mr-2 animate-spin" />
                                            Cargando
                                        </>
                                    ) : (
                                        "Guardar"
                                    )}
                                </Button>
                            </>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            <AlertDialog
                open={deleteShift}
                onOpenChange={() => setDeleteShift(!edit)}>
                <AlertDialogContent>
                    <AlertDialogHeader>
                        <AlertDialogTitle>
                            {"Estas seguro que deseas eliminar esta visita"}
                        </AlertDialogTitle>
                        <AlertDialogDescription className="gap-2">
                            <p className="mb-2">
                                Esta acción no se podrá revertir
                            </p>
                        </AlertDialogDescription>
                    </AlertDialogHeader>

                    <AlertDialogFooter>
                        <AlertDialogCancel
                            onClick={() => setDeleteShift(!edit)}>
                            Atrás
                        </AlertDialogCancel>
                        <AlertDialogAction
                            onClick={() => handleDelete()}
                            className="bg-red-200 hover:bg-red-300">
                            {"Eliminar visita"}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
};
